//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Optimization.js";
import "../no/Builder.js";
let d=[[[0,"AbsoluteConvergenceCriteria",1,0],[0,"AlgorithmType",1,0],[0,"ConvergenceSpeedType",1,0],[0,"IsShowGraph",1,0],[0,"IsUpdateDisp",1,0],[0,"MaxNumberIteration",1,0],[0,"MaxTime",1,0],[0,"OptimizationType",1,0],[0,"RelativeConvergenceCriteria",1,0],[0,"StudyName",1,0]],[[[],"RunOptimization",{},0,0],[["numObjectives"],"GetOptimizationObjectives",{R_:{objectives:""}},0,0],[["attributeNames","attributeObjects","objectiveTypes","objectiveTargetValues"],"SetOptimizationObjectives",{},4,0],[["numVariables"],"GetOptimizationVariables",{R_:{variables:""}},0,0],[["attributeNames","attributeObjects","variableTypes","variableLowerLimitValue","variableUpperLimitValue"],"SetOptimizationVariables",{},5,0],[["numConstraints"],"GetOptimizationConstraints",{R_:{constraints:""}},0,0],[["attributeNames","attributeObjects","constraintTypes","constraintLowerLimitValue","constraintUpperLimitValue","constraintLimitType"],"SetOptimizationConstraints",{},6,0],[[],"BuildAllObjectives",{},0,0],[[],"RemoveAllObjectives",{},0,0],[[],"BuildAllVariables",{},0,0],[[],"RemoveAllVariables",{},0,0],[[],"BuildAllConstraints",{},0,0],[[],"RemoveAllConstraints",{},0,0]],[]];
SPLM.Optimization.OptimizationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Optimization.OptimizationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Optimization.OptimizationBuilder.OptimizationObjective = class{
    constructor(attributeName,attributeObject,objectiveType,objectiveTargetValue){
        this.attributeName=attributeName;this.attributeObject=attributeObject;this.objectiveType=objectiveType;this.objectiveTargetValue=objectiveTargetValue;}
    get Attributename(){return this.attributeName}
    set Attributename(val){this.attributeName = val}
    get Attributeobject(){return this.attributeObject}
    set Attributeobject(val){this.attributeObject = val}
    get Objectivetype(){return this.objectiveType}
    set Objectivetype(val){this.objectiveType = val}
    get Objectivetargetvalue(){return this.objectiveTargetValue}
    set Objectivetargetvalue(val){this.objectiveTargetValue = val}
};

SPLM.Optimization.OptimizationBuilder.OptimizationVariable = class{
    constructor(attributeName,attributeObject,variableType,variableLowerLimitValue,variableUpperLimitValue){
        this.attributeName=attributeName;this.attributeObject=attributeObject;this.variableType=variableType;this.variableLowerLimitValue=variableLowerLimitValue;this.variableUpperLimitValue=variableUpperLimitValue;}
    get Attributename(){return this.attributeName}
    set Attributename(val){this.attributeName = val}
    get Attributeobject(){return this.attributeObject}
    set Attributeobject(val){this.attributeObject = val}
    get Variabletype(){return this.variableType}
    set Variabletype(val){this.variableType = val}
    get Variablelowerlimitvalue(){return this.variableLowerLimitValue}
    set Variablelowerlimitvalue(val){this.variableLowerLimitValue = val}
    get Variableupperlimitvalue(){return this.variableUpperLimitValue}
    set Variableupperlimitvalue(val){this.variableUpperLimitValue = val}
};

SPLM.Optimization.OptimizationBuilder.OptimizationConstraint = class{
    constructor(attributeName,attributeObject,constraintType,constraintLowerLimitValue,constraintUpperLimitValue,constraintLimitType){
        this.attributeName=attributeName;this.attributeObject=attributeObject;this.constraintType=constraintType;this.constraintLowerLimitValue=constraintLowerLimitValue;this.constraintUpperLimitValue=constraintUpperLimitValue;this.constraintLimitType=constraintLimitType;}
    get Attributename(){return this.attributeName}
    set Attributename(val){this.attributeName = val}
    get Attributeobject(){return this.attributeObject}
    set Attributeobject(val){this.attributeObject = val}
    get Constrainttype(){return this.constraintType}
    set Constrainttype(val){this.constraintType = val}
    get Constraintlowerlimitvalue(){return this.constraintLowerLimitValue}
    set Constraintlowerlimitvalue(val){this.constraintLowerLimitValue = val}
    get Constraintupperlimitvalue(){return this.constraintUpperLimitValue}
    set Constraintupperlimitvalue(val){this.constraintUpperLimitValue = val}
    get Constraintlimittype(){return this.constraintLimitType}
    set Constraintlimittype(val){this.constraintLimitType = val}
};

SPLM.Optimization.OptimizationBuilder.OptimizationTargetType = Object.freeze({
    "Minimum" : "Minimum", "Maximum" : "Maximum", "Target" : "Target"});

SPLM.Optimization.OptimizationBuilder.OptimizationAttributeType = Object.freeze({
    "Expression" : "Expression", "KFAttribute" : "KFAttribute", "GeometryParameter" : "GeometryParameter"});

SPLM.Optimization.OptimizationBuilder.OptimizationConstraintLimitType = Object.freeze({
    "Upper" : "Upper", "Lower" : "Lower"});

SPLM.Optimization.OptimizationBuilder.OptimizationAlgorithmType = Object.freeze({
    "SimulatedAnnealing" : "SimulatedAnnealing", "GlobalSimplex" : "GlobalSimplex", "Powell" : "Powell", "ConjugateGradient" : "ConjugateGradient", "Lexicographic" : "Lexicographic", "PatternSwarm" : "PatternSwarm"});

SPLM.Optimization.OptimizationBuilder.OptimizationConvergenceSpeedType = Object.freeze({
    "Slow" : "Slow", "Medium" : "Medium", "Fast" : "Fast", "Infinite" : "Infinite"});

export default SPLM;